(function () {
    'use strict';

    angular
        .module('app')
        .controller('videolistController', videolistController);

    videolistController.$inject = ['$scope', 'videoService', '$sce'];
    function videolistController($scope, videoService, $sce) {

        /* jshint validthis:true */
        var vm = this;
        vm.videoModel = null;
        vm.getVideomodel = getVideomodel;
        vm.getNextResults = getNextResults;
        vm.convertToTrustedHtml = convertToTrustedHtml;
        vm.totalVideos = null;
        vm.skip = 3;
        vm.disableInfinteScroll = true;
        vm.take = 3;

        function getNextResults(take) {
            if (vm.totalVideos > vm.skip) {
                vm.disableInfinteScroll = true;
                videoService.getVideoData(take, vm.skip).then(
                    function (result) {
                        vm.videoModel.videos = vm.videoModel.videos.concat(result.data.videos);
                        vm.skip = vm.videoModel.videos.length;
                        vm.totalVideos = result.data.totalCount;
                        vm.disableInfinteScroll = !result.data.showMore;
                    },
                    function(reason) {
                    },
                    function(error) {
                        Console.log(error);
                    }
                );
            } else {
                vm.showMore = false;
            }
        }
        function getVideomodel(take, skip) {
            videoService.getVideoData(take, 0).then(
                    function (result) {
                        console.log(result.data);
                        vm.videoModel = result.data;
                        vm.totalVideos = result.data.totalCount;
                        vm.disableInfinteScroll = !result.data.showMore;
                    },
                    function (reason) {
                    },
                    function (error) {
                        Console.log(error);
                    }
                );
        }

        function activate() {
                getVideomodel(3, 0);
        }
        activate();

        function convertToTrustedHtml(embedCode) {
            return $sce.trustAsHtml(embedCode);
        }
    }
})();




